import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'sl-not-logged-footer',
    templateUrl: './not-logged-footer.component.html',
    styleUrls: ['./not-logged-footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotLoggedFooterComponent {
    date = new Date();
}
